import React from 'react';

import {
  listManagedCdqLeads,
  ManagedCdqLead,
  ManagedLeadCategory,
} from '../../services/api/managed-leads/managedLeads';
import { MANAGED_LEAD_DETAIL_BASE_PATHS } from '../../config/managedLeadNavigation';
import ManagedLeadCard from './components/ManagedLeadCard';
import ManagedProductLeadListPage from './components/ManagedProductLeadListPage';
import { EMPTY_MANAGED_LEAD_VALUE } from './managedLeadFormatting';

const occupationDisplayValue = (value: ManagedCdqLead['occupation']) => {
  if (
    typeof value === 'string' &&
    (/^[a-z0-9]+(?:_[a-z0-9]+)+$/i.test(value) || /^\d+$/.test(value))
  ) {
    return EMPTY_MANAGED_LEAD_VALUE;
  }

  return value;
};

interface ManagedCdqListPageProps {
  category?: ManagedLeadCategory;
}

const ManagedCdqListPage = ({
  category = 'in_progress',
}: ManagedCdqListPageProps) => {
  return (
    <ManagedProductLeadListPage
      category={category}
      product="cessioni-del-quinto"
      listLeads={listManagedCdqLeads}
      loadingMessage="Caricamento cessioni del quinto…"
      ownerMissingMessage="Non hai un responsabile HubSpot associato. Non ci sono cessioni del quinto da mostrare."
      searchLabel="Cerca cessioni del quinto per nome o email"
      renderLead={(lead, context) => (
        <ManagedLeadCard
          key={lead.id}
          lead={lead}
          productDatum={{
            label: 'Occupazione',
            value: occupationDisplayValue(lead.occupation),
          }}
          detailBasePath={MANAGED_LEAD_DETAIL_BASE_PATHS['cessioni-del-quinto']}
          returnTo={context.returnTo}
          showNeedsUpdate={context.showNeedsUpdate}
          updateRequestProduct={
            context.showUpdateRequest ? 'cessioni-del-quinto' : undefined
          }
        />
      )}
    />
  );
};

export default ManagedCdqListPage;
